module.exports = __webpack_public_path__ + "img/pdf-icon-new-active.3f15ca7e.svg";